/** Texto para comparar: sin acentos, en minúsculas y con cualquier separador reducido a un espacio. */
export const normalizarTexto = (texto: string): string =>
  texto.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
